import api from './client';
import { Vote } from './types';

export const vote = async (vote: Vote) => {
  const response = await api.post('votes/', [vote]);
  return response.data;
};
